module.exports = __webpack_public_path__ + "static/media/headerUser.75d3df71.svg";